import { render, staticRenderFns } from "./KuehneLogo.vue?vue&type=template&id=121dd25c&"
import script from "./KuehneLogo.vue?vue&type=script&lang=js&"
export * from "./KuehneLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports